import {Component, Inject} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogClose, MatDialogContent, MatDialogTitle} from '@angular/material/dialog';
import {MarkantElementsModule} from '@markant/elements-angular';

@Component({
  selector: 'app-confirm-dialog',
  templateUrl: './confirm-dialog.component.html',
  styleUrls: ['./confirm-dialog.component.scss'],
  standalone: true,
  imports: [MarkantElementsModule, MatDialogClose, MatDialogContent, MatDialogTitle],
})
export class ConfirmDialogComponent {
  constructor(@Inject(MAT_DIALOG_DATA) public conf: ConfirmDialogConfig) {}
}
export interface ConfirmDialogConfig {
  title: string;
  message: string;
}
